module.exports = __webpack_public_path__ + "img/label5.444d848b.png";